// Reload other tabs/windows when a login or logout happens in one of them.
// The `storage` event only fires in the tabs that did not perform the change.

const TOKEN_STORAGE_KEY = 'token';

export function hasSessionChanged(event, currentToken) {
    // key is null when the storage was cleared, e.g. on logout
    if (event.key !== null && event.key !== TOKEN_STORAGE_KEY) return false;

    let newToken = null;
    if (event.key === TOKEN_STORAGE_KEY && event.newValue) {
        try {
            newToken = JSON.parse(event.newValue);
        } catch (err) {
            newToken = event.newValue;
        }
    }

    return (newToken || null) !== (currentToken || null);
}

window.addEventListener('storage', function (event) {
    if (event.storageArea !== localStorage) return;

    if (hasSessionChanged(event, app.store.getState().session.authToken)) {
        // Don't save the store state, it would restore the old session after reload
        location.reload();
    }
});
